import angular from 'angular';

import { ProfileModule } from './profile/profile.module';

import { OrdersComponent } from './orders.component';

export const AccountModule = angular
    .module('oo.account', [ProfileModule])
    .component('orders', OrdersComponent)
    .name;
